import { getStudentSession } from './auth'

export function getRequestToken(storeToken) {
  const student = getStudentSession()
  if (student && student.token) {
    return student.token
  }

  return storeToken || ''
}



// WEBPACK FOOTER //
// ./src/utils/request-token.js